console.log("custom-quantity loaded on collection");

// Qty +/-
document.addEventListener("click", (e) => {
  const wrap = e.target.closest("[data-qty-wrapper]");
  if (!wrap) return;

  const plus = e.target.closest("[data-qty-plus]");
  const minus = e.target.closest("[data-qty-minus]");
  if (!plus && !minus) return;

  e.preventDefault();

  const input = wrap.querySelector('input[name="quantity"]');
  if (!input || input.disabled) return;

  const min = input.min ? parseInt(input.min, 10) : 1;
  const max = input.max ? parseInt(input.max, 10) : Infinity;
  let val = input.value ? parseInt(input.value, 10) : min;

  if (plus) val = Math.min(max, val + 1);
  if (minus) val = Math.max(min, val - 1);

  input.value = val;
  input.dispatchEvent(new Event("change", { bubbles: true }));
}, true);

// AJAX add-to-cart
document.addEventListener("submit", async (e) => {
  const form = e.target.closest("form[data-ajax-add]");
  if (!form) return;

  e.preventDefault();

  const btn = form.querySelector('button[type="submit"]');
  if (btn) {
    btn.disabled = true;
    btn.setAttribute("aria-busy", "true");
  }

  try {
    // 1) Add to cart (AJAX)
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
      body: new URLSearchParams(new FormData(form)),
    });

    if (!res.ok) throw new Error("Add to cart failed");

    // 2) Re-render cart UI sections (drawer + bubble)
    const sections = ["cart-drawer", "cart-icon-bubble"];
    const secRes = await fetch(`/?sections=${sections.join(",")}`, { credentials: "same-origin" });
    const html = await secRes.json();

    // Update cart drawer
    if (html["cart-drawer"]) {
      const drawer = document.querySelector("cart-drawer");
      if (drawer) {
        const tmp = document.createElement("div");
        tmp.innerHTML = html["cart-drawer"];
        const fresh = tmp.querySelector("cart-drawer");
        if (fresh) drawer.replaceWith(fresh);
      }
    }

    // Update cart icon bubble
    if (html["cart-icon-bubble"]) {
      const bubble = document.querySelector("#cart-icon-bubble");
      if (bubble) {
        const tmp = document.createElement("div");
        tmp.innerHTML = html["cart-icon-bubble"];
        const fresh = tmp.querySelector("#cart-icon-bubble");
        if (fresh) bubble.replaceWith(fresh);
      }
    }

    // 3) Open cart drawer (if enabled)
    const cartLink = document.querySelector('a[href="/cart"], a[href^="/cart"]');
    const drawerEl = document.querySelector("cart-drawer");
    if (drawerEl && cartLink) cartLink.click();

  } catch (err) {
    console.error(err);
    alert("Could not add to cart. Please try again.");
  } finally {
    if (btn) {
      btn.disabled = false;
      btn.removeAttribute("aria-busy");
    }
  }
}, true);

